export const baseEnvironment = {
    production: false,
    version: "",
    buildNumber: "",
    commitHash: "",
    enableLocalSentryCapture: false,
    cloudFunctionsUrl: "https://us-central1-toyota-digital.cloudfunctions.net"
};
